import React from 'react';
import aboutUsData from '../../data/about-us.json';

const values = aboutUsData.values;
const milestones = aboutUsData.milestones;
const valuesSection = aboutUsData.valuesSection;
const timelineSection = aboutUsData.timelineSection;

export default function AboutContent() {
    return (
        <section className="au-content">
            <style>{`
                .au-content {
                    background: var(--eventflow-black);
                    padding: 100px 0;
                    position: relative;
                    overflow: hidden;
                }
                .au-content::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 80% 20%, rgba(var(--eventflow-primary-rgb),0.1) 0%, transparent 55%),
                        radial-gradient(ellipse at 10% 80%, rgba(var(--eventflow-base-rgb),0.07) 0%, transparent 50%);
                    pointer-events: none;
                }

                /* ── story block ── */
                .au-story {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 64px;
                    align-items: center;
                    margin-bottom: 100px;
                }
                .au-story__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 16px;
                }
                .au-story__tag::before, .au-story__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .au-story__title {
                    font-family: var(--eventflow-font);
                    font-size: 44px; font-weight: 900;
                    color: #fff; line-height: 1.1;
                    letter-spacing: -1px; margin-bottom: 20px;
                }
                .au-story__title span { color: var(--eventflow-base); }
                .au-story__body p {
                    font-family: var(--eventflow-font);
                    font-size: 15px; color: rgba(255,255,255,0.55);
                    line-height: 1.8; margin-bottom: 16px;
                }
                .au-story__body p:last-child { margin-bottom: 0; }
                .au-story__imgs {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 300px;
                }
                .au-story__logo {
                    max-width: 280px;
                    filter: brightness(1.5) contrast(1.1);
                    transition: transform 0.4s;
                }
                .au-story__logo:hover {
                    transform: scale(1.05);
                }

                /* ── values ── */
                .au-values { margin-bottom: 100px; }
                .au-values__grid {
                    display: grid;
                    grid-template-columns: repeat(4,1fr);
                    gap: 16px;
                    margin-top: 48px;
                }
                .au-value {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 14px;
                    padding: 28px 22px;
                    transition: all 0.3s;
                }
                .au-value:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.35);
                    transform: translateY(-4px);
                    box-shadow: 0 16px 40px rgba(0,0,0,0.3);
                }
                .au-value__icon {
                    width: 48px; height: 48px;
                    border-radius: 12px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    display: flex; align-items: center; justify-content: center;
                    margin-bottom: 16px;
                    transition: background 0.3s;
                }
                .au-value:hover .au-value__icon { background: rgba(var(--eventflow-base-rgb),0.2); }
                .au-value__icon i { font-size: 20px; color: var(--eventflow-base); }
                .au-value__title {
                    font-family: var(--eventflow-font);
                    font-size: 15px; font-weight: 700;
                    color: #fff; margin-bottom: 10px;
                }
                .au-value__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px; line-height: 1.65;
                    color: rgba(255,255,255,0.45); margin: 0;
                }

                /* ── timeline ── */
                .au-timeline { position: relative; }
                .au-timeline__line {
                    position: absolute;
                    left: 50%; top: 0; bottom: 0;
                    width: 1px;
                    background: rgba(255,255,255,0.07);
                    transform: translateX(-50%);
                }
                .au-timeline__items {
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                    margin-top: 48px;
                    position: relative;
                }
                .au-timeline__item {
                    display: grid;
                    grid-template-columns: 1fr 60px 1fr;
                    align-items: center;
                    gap: 24px;
                }
                .au-timeline__item:nth-child(even) .au-timeline__text { order: 3; text-align: left; }
                .au-timeline__item:nth-child(even) .au-timeline__empty { order: 1; }
                .au-timeline__text {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 12px;
                    padding: 24px;
                    transition: border-color 0.3s;
                }
                .au-timeline__text:hover { border-color: rgba(var(--eventflow-base-rgb),0.3); }
                .au-timeline__year {
                    font-family: 'Courier New', monospace;
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 2px; color: var(--eventflow-base);
                    margin-bottom: 6px;
                }
                .au-timeline__title {
                    font-family: var(--eventflow-font);
                    font-size: 16px; font-weight: 700;
                    color: #fff; margin-bottom: 8px;
                }
                .au-timeline__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.45);
                    line-height: 1.6; margin: 0;
                }
                .au-timeline__dot {
                    width: 44px; height: 44px;
                    border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 2px solid rgba(var(--eventflow-base-rgb),0.3);
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto;
                    font-family: 'Courier New', monospace;
                    font-size: 11px; font-weight: 700;
                    color: var(--eventflow-base);
                    position: relative; z-index: 1;
                }
                .au-timeline__empty {}

                /* section header shared */
                .au-sec-tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 12px;
                    justify-content: center;
                }
                .au-sec-tag::before, .au-sec-tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .au-sec-title {
                    font-family: var(--eventflow-font);
                    font-size: 44px; font-weight: 900;
                    color: #fff; line-height: 1.1;
                    letter-spacing: -1px; margin-bottom: 12px;
                    text-align: center;
                }
                .au-sec-title span { color: var(--eventflow-base); }
                .au-sec-sub {
                    font-family: var(--eventflow-font);
                    font-size: 15px; color: rgba(255,255,255,0.45);
                    max-width: 520px; margin: 0 auto; line-height: 1.75;
                    text-align: center;
                }

                @media (max-width: 991px) {
                    .au-story { grid-template-columns: 1fr; gap: 40px; }
                    .au-values__grid { grid-template-columns: repeat(2,1fr); }
                    .au-timeline__item { grid-template-columns: 1fr; }
                    .au-timeline__line { display: none; }
                    .au-timeline__item:nth-child(even) .au-timeline__text { order: unset; }
                    .au-timeline__item:nth-child(even) .au-timeline__empty { display: none; }
                    .au-timeline__empty { display: none; }
                    .au-timeline__dot { margin: 0 0 12px; }
                    .au-timeline__item { gap: 12px; }
                }
                @media (max-width: 576px) {
                    .au-values__grid { grid-template-columns: 1fr; }
                    .au-story__imgs { min-height: 200px; }
                    .au-sec-title { font-size: 32px; }
                    .au-story__title { font-size: 32px; }
                }
            `}</style>

            <div className="container">

                {/* ── Our Story ── */}
                <div className="au-story">
                    <div className="wow fadeInLeft" data-wow-delay="100ms">
                        <div className="au-story__tag">{aboutUsData.story.tag}</div>
                        <h2 className="au-story__title">
                            {aboutUsData.story.title} <span>{aboutUsData.story.titleAccent}</span>
                        </h2>
                        <div className="au-story__body">
                            {aboutUsData.story.paragraphs.map((p, i) => (
                                <p key={i}>{p}</p>
                            ))}
                        </div>
                    </div>
                    <div className="au-story__imgs wow fadeInRight" data-wow-delay="200ms">
                        <img className="au-story__logo" src={aboutUsData.story.images[0].src} alt={aboutUsData.story.images[0].alt} />
                    </div>
                </div>

                {/* ── Our Values ── */}
                <div className="au-values">
                    <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                        <div className="au-sec-tag">{valuesSection.tag}</div>
                        <h2 className="au-sec-title">{valuesSection.title} <span>{valuesSection.titleAccent}</span></h2>
                        <p className="au-sec-sub">{valuesSection.subtitle}</p>
                    </div>
                    <div className="au-values__grid wow fadeInUp" data-wow-delay="200ms">
                        {values.map((v, i) => (
                            <div className="au-value" key={i}>
                                <div className="au-value__icon"><i className={`fa ${v.icon}`} /></div>
                                <div className="au-value__title">{v.title}</div>
                                <p className="au-value__desc">{v.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── Timeline ── */}
                <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                    <div className="au-sec-tag">{timelineSection.tag}</div>
                    <h2 className="au-sec-title">{timelineSection.title} <span>{timelineSection.titleAccent}</span></h2>
                </div>
                <div className="au-timeline wow fadeInUp" data-wow-delay="200ms">
                    <div className="au-timeline__line" />
                    <div className="au-timeline__items">
                        {milestones.map((m, i) => (
                            <div className="au-timeline__item" key={i}>
                                {i % 2 === 0 ? (
                                    <>
                                        <div className="au-timeline__text">
                                            <div className="au-timeline__year">{m.year}</div>
                                            <div className="au-timeline__title">{m.title}</div>
                                            <p className="au-timeline__desc">{m.desc}</p>
                                        </div>
                                        <div className="au-timeline__dot">{m.year.slice(2)}</div>
                                        <div className="au-timeline__empty" />
                                    </>
                                ) : (
                                    <>
                                        <div className="au-timeline__empty" />
                                        <div className="au-timeline__dot">{m.year.slice(2)}</div>
                                        <div className="au-timeline__text">
                                            <div className="au-timeline__year">{m.year}</div>
                                            <div className="au-timeline__title">{m.title}</div>
                                            <p className="au-timeline__desc">{m.desc}</p>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}
